import AuthState from '@/models/auth/auth-state.model';
import UserLogin from '@/models/auth/user-login.model';
import RememberPassword from '@/models/auth/auth-remember-password.model';
import RecoveryPassword from '@/models/auth/auth-recovery-password.model';
import { GetterTree } from "vuex";

export const getters: GetterTree<AuthState, {}> = {
    getUserLogin(state): UserLogin {
        return state.userLogin;
    },
    getRememberPassword(state): RememberPassword {
        return state.rememberPassword;
    },
    getRecoveryPassword(state): RecoveryPassword {
        return state.recoveryPassword;
    },
    getIsLoading(state): boolean {
        return state.isLoading;
    },
    getIsSubmitted(state): boolean {
        return state.isSubmitted;
    },
    getIsErrorLogin(state): boolean {
        return state.isErrorLogin;
    },
    getIsErrorRequest(state): boolean {
        return state.isErrorRequest;
    }
};
